import { c as _c } from "react/compiler-runtime";
import { twMerge } from "tailwind-merge";
interface VerticalCurveProps {
  className: string;
}
export default function VerticalCurve(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  const t1 = `h-full fill-primary stroke-primary ${className}`;
  let t2;
  if ($[0] !== t1) {
    t2 = twMerge(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path id="Intersection_44" data-name="Intersection 44" d="M0,100l0-.015c.2-.68,1.96-6.9,3.686-15.716C4.761,78.8,5.614,73.387,6.226,68.18A158.9,158.9,0,0,0,7.378,49.774,156.6,156.6,0,0,0,6.3,32.1c-.579-5.036-1.387-10.272-2.4-15.562C2.082,7.078.115.289.032,0H7.38V100Z" transform="translate(0 -0.002)" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.381 99.998" className={t2}>{t3}</svg>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}